import { gql } from '@apollo/client';
import type { VehicleFilters } from '@apiTypes';
import useCachedQuery from '../../../core/hooks/useCachedQuery';

const defaultVehicleFilters: Omit<VehicleFilters, 'kw' | '__typename'> = {
    manufacturerName: [],
    model: [],
    ratedPower: [],
    typeNumbers: [],
    typeAcceptanceList: [],
    ccmStart: 0,
    ccmEnd: 0,
};

const vehicleFiltersQuery = gql`
    query vehicleFilters(
        $search: String
        $manufacturerName: [String!]
        $model: [String!]
        $ratedPower: [String!]
        $typeNumbers: [String!]
        $typeAcceptanceList: [String!]
        $ccmRangeStart: Int
        $ccmRangeEnd: Int
    ) {
        vehicleFilters(
            search: $search
            manufacturerName: $manufacturerName
            model: $model
            ratedPower: $ratedPower
            typeNumbers: $typeNumbers
            typeAcceptanceList: $typeAcceptanceList
            ccmRangeStart: $ccmRangeStart
            ccmRangeEnd: $ccmRangeEnd
        ) {
            manufacturerName
            model
            ratedPower
            typeNumbers
            typeAcceptanceList
            ccmStart
            ccmEnd
        }
    }
`;

const useVehicleFilters = ({
    search,
    make,
    model,
    ccmRangeStart,
    ccmRangeEnd,
    type,
    typeApprovalList,
}: {
    search?: string;
    make?: string;
    model?: string;
    ccmRangeStart?: number;
    ccmRangeEnd?: number;
    type?: string;
    typeApprovalList?: string[];
}) => {
    const { data, loading, error } = useCachedQuery<{
        vehicleFilters: VehicleFilters;
    }>(vehicleFiltersQuery, {
        fetchPolicy: 'cache-first',
        variables: {
            search,
            model,
            manufacturerName: make,
            ccmRangeStart,
            ccmRangeEnd,
            typeNumbers: type,
            typeAcceptanceList: typeApprovalList,
        },
    });

    return {
        vehicleFilters: data?.vehicleFilters ?? defaultVehicleFilters,
        loading,
        error,
    };
};

export default useVehicleFilters;
